import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BackButtonBlocker {
  private intervalId: ReturnType<typeof globalThis.setInterval> | null = null;

  private readonly popStateHandler = this.blockBack.bind(this);
  private readonly keydownHandler = this.blockRefresh.bind(this);
  private readonly beforeUnloadHandler = this.preventUnload.bind(this);

  private readonly isTestEnvironment = this.detectTestEnvironment();

  enableBlocker(): void {
    const win = globalThis.window;
    if (!win) {
      return;
    }

    this.disableBlocker();

   
    win.history.pushState(null, '', win.location.href);
    win.addEventListener('popstate', this.popStateHandler);

    this.intervalId = globalThis.setInterval(() => {
      win.history.pushState(null, '', win.location.href);
    }, 500);

    
    document.addEventListener('keydown', this.keydownHandler);

 
    if (!this.isTestEnvironment) {
      win.addEventListener('beforeunload', this.beforeUnloadHandler);
    }
  }

  disableBlocker(): void {
    const win = globalThis.window;
    if (!win) {
      return;
    }

    win.removeEventListener('popstate', this.popStateHandler);
    document.removeEventListener('keydown', this.keydownHandler);
    win.removeEventListener('beforeunload', this.beforeUnloadHandler);

    if (this.intervalId !== null) {
      globalThis.clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  private blockBack(): void {
    const win = globalThis.window;
    if (win) {
      win.history.pushState(null, '', win.location.href);
    }
  }
  private blockRefresh(event: KeyboardEvent): void {
    if (event.key === 'F5') {
      event.preventDefault();
    }

    if ((event.ctrlKey || event.metaKey) && event.key === 'r') {
      event.preventDefault();
    }

    if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'r') {
      event.preventDefault();
    }
  }

  private preventUnload(event: BeforeUnloadEvent): void {
    event.preventDefault();
  }
  private detectTestEnvironment(): boolean {
    return (
      (globalThis as any).jasmine !== undefined ||
      (window as any).__karma__ !== undefined
    );
  }

  allowNavigation(): void {
    this.disableBlocker();
  }

}
